import script from "./FormButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FormButton.vue?vue&type=script&setup=true&lang=js"

import "./FormButton.vue?vue&type=style&index=0&id=6e9c27a6&lang=css"

const __exports__ = script;

export default __exports__